import { TableCell, Table, TableRow, TableHead, TableBody, TableContainer, Paper, Tooltip, Button } from '@mui/material';
import { Edit as EditIcon, Delete as DeleteIcon, } from "@mui/icons-material";
import { DeletePopUp, NoRecordFound, PageLoader, STableLoader } from '../../../../shared_elements';
import HolidayRulesCru from './HolidayRulesCru';
import { useEffect, useState } from 'react';
import { useSnackbar } from 'notistack';
import { trackActivity } from '../../../../utils/mixpanel';
import { deleteHolidayRulesApi, getHolidayRulesApi } from '../apiService';
import { globalDeleteService, globalGetService } from '../../../../utils/globalApiServices';
import { checkApiStatus } from '../../../../utils';
import { PermissionWrapper } from '../../../../wrappers';
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';

const LessMoreComp = ({ name }) => {
  const [isOpen, setIsOpen] = useState(false);
  if (!name) return <>--</>;
  const isLongText = name.length > 50;
  return (
    <>
      {isLongText ? (
        <>
          {isOpen ? name : name.substring(0, 50)}
          <span style={{ color: "#0e7fe1", cursor: "pointer" }} onClick={(e) => { e.preventDefault(); setIsOpen(!isOpen); }} > {isOpen ? " ..less" : " ..more"} </span>
        </>
      ) : ( name )}
    </>
  );
}

const HolidayRules = ({ calenderSlug, calenderDetail }) => {
    const { enqueueSnackbar } = useSnackbar()
    const [isLoading, setLoading] = useState(false)
    const [skeletonLoader, setSkeletonLoader] = useState(false)
    const [deleteHolidayRules, setDeleteHolidayRules] = useState({ modal: false, data: null, })
    const [holidayRules, setHolidayRules] = useState({});
    const [holidayRulesCRU, setHolidayRulesCRU] = useState({ modal: false, data: null, mode: '' });

    useEffect(() => {
       if(calenderSlug) {getHolidayRules('skeletonLoader', { per_page: 50 })}
        trackActivity('Page Viewed', { page_title: 'Calendar' })
    }, [calenderSlug])

    const getHolidayRules = async (loaderType, query = {}) => {
        loaderType === 'skeletonLoader' ? setSkeletonLoader(true) : setLoading(true);
        try {
            const response = await globalGetService(getHolidayRulesApi({ calenderSlug, ...query }));
            if (checkApiStatus(response)) {
                setHolidayRules(response?.data?.data || {});
            }
        } finally {
            loaderType === 'skeletonLoader' ? setSkeletonLoader(false) : setLoading(false);
        }
    };
    
    const deleteholidayListFn = () => {
        setLoading(true);
        globalDeleteService(deleteHolidayRulesApi({ calenderSlug }), { ids: [deleteHolidayRules?.data?.id] })
            .then(response => {
                if (checkApiStatus(response)) {
                    trackActivity('Item Deleted', { page_title: `Delete Exceptional Working Day`, success_msg: response?.data?.message, item_ids: deleteHolidayRules?.data, response: response?.data })
                    setDeleteHolidayRules({ modal: false, data: null });
                    getHolidayRules('', { per_page: holidayRules?.pagination?.per_page });
                    // setLoading(false);
                    enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                } else {
                    setLoading(false);
                    enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                    trackActivity('Item Deleted', { page_title: `Delete Exceptional Working Day`, error_msg: response?.data?.message, item_ids: deleteHolidayRules?.data, response: response?.data })
                }
            })
    }

    const handleItemClicked = (page_type) => {
        trackActivity('Item Clicked', { page_title: `Holiday Rules`, page_type: page_type, })
    }
    return (
        <TableContainer className="lease-detail-table">
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <h2 style={{ fontSize: '14px', fontWeight: '600' }}>Exceptional Working Days</h2>
                <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "calender", operationType: ['C'] }}>
                    <Button variant="contained" size='small' startIcon={<AddOutlinedIcon />} className='btn-primary action-btn-start-icon' onClick={() => { setHolidayRulesCRU({ modal: true, data: null, mode: 'add' }); handleItemClicked('Add Item Button') }}>Add Exceptional Working Day</Button>
                </PermissionWrapper>
            </div>
            <div style={holidayRules?.list?.length > 0 ? { overflow: "auto", height: "280px" } : { overflow: "auto", height: "auto", maxHeight: "280px" }}>
                {skeletonLoader ? <STableLoader count={4} rowCount={6} /> : (
                    <>
                        <Table className="mui-table-format" stickyHeader>
                            <TableHead>
                                <TableRow>
                                    <TableCell sx={{minWidth: '100px'}}>Name</TableCell>
                                    <TableCell sx={{minWidth: '100px'}}>Override Type</TableCell>
                                    <TableCell sx={{minWidth: '100px'}}>Weekdays</TableCell>
                                    <TableCell sx={{minWidth: '100px'}}>Applied To</TableCell>
                                    <TableCell sx={{whiteSpace: 'nowrap'}}>Occurrence</TableCell>
                                    <TableCell sx={{ textAlign: "right", minWidth: '100px' }}>
                                        <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "calendar", operationType: ['C' || 'U' || 'D'] }}>
                                            Action(s)
                                        </PermissionWrapper>
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {holidayRules?.list?.length > 0 && holidayRules?.list?.map((item, index) => {
                                    return (
                                        <TableRow key={item?.id || index}>
                                            <TableCell> <div style={{ width: item?.holiday_name?.length > 50 ? "250px" : ''}}><LessMoreComp name={item?.holiday_name ? item?.holiday_name : "--"} /></div></TableCell>
                                            <TableCell>{item?.override_type?.label || '--'}</TableCell>
                                            <TableCell>{item?.weekday?.label || '--'}</TableCell>
                                            <TableCell>{item?.applies_to?.label || '--'}</TableCell>
                                            <TableCell>
                                                {Array.isArray(item?.occurrence) && item.occurrence.length
                                                    ? item.occurrence
                                                        .map(n => `${n}${["st", "nd", "rd"][n - 1] || "th"}`)
                                                        .join(", ")
                                                    : "--"}
                                            </TableCell>
                                            <TableCell sx={{ textAlign: "right" }}>
                                                <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "calendar", operationType: ['U'] }}>
                                                    <Tooltip title="Edit" arrow> <EditIcon onClick={() => { setHolidayRulesCRU({ modal: true, data: item, mode: 'edit' }); handleItemClicked('edit Item Button') }} fontSize="small" color="primary" sx={{ cursor: "pointer" }} /> </Tooltip>
                                                </PermissionWrapper>
                                                <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "calendar", operationType: ['D'] }}>
                                                    <Tooltip title="Delete" arrow> <DeleteIcon onClick={() => { setDeleteHolidayRules({ modal: true, data: item, }); handleItemClicked('delete Item Button') }} fontSize="small" color="error" sx={{ cursor: "pointer" }} /> </Tooltip>
                                                </PermissionWrapper>
                                            </TableCell>
                                        </TableRow>
                                    );
                                })}
                            </TableBody>
                        </Table></>)}
                        {!skeletonLoader && holidayRules?.list?.length === 0 ? <NoRecordFound /> : null}
            </div>
            {holidayRulesCRU.modal &&
                <HolidayRulesCru
                    holidayRulesCRU={holidayRulesCRU}
                    modeType={holidayRulesCRU?.mode}
                    calenderSlug={calenderSlug}
                    calenderDetail={calenderDetail}
                    getResponseBack={() => getHolidayRules("", { per_page: holidayRules?.pagination?.per_page })}
                    onToggleModal={() => setHolidayRulesCRU({ modal: false, data: null, mode: '' })}
                />
            }
            {deleteHolidayRules.modal ?
                <DeletePopUp
                    modal={deleteHolidayRules.modal}
                    title={'Delete Exceptional Working Day'}
                    content={`Are you sure, you want to Delete?`}
                    onToggleModal={() => setDeleteHolidayRules({ modal: false, data: null })}
                    onDeleteRecords={() => deleteholidayListFn()}
                /> : null}
            {isLoading ? <PageLoader /> : null}
        </TableContainer>
    )
}

export default HolidayRules
